import { ChangeEvent, CSSProperties, KeyboardEvent, useEffect, useRef } from 'react'
import clsx from 'clsx'
import { InputGroupTextarea } from '@/components/ui/input-group'

type ComposerTextareaProps = {
  value: string
  onChange: (value: string) => void
  onSubmit: () => void
  placeholder?: string
  disabled?: boolean
  readOnly?: boolean
  maxHeight?: number
  /** Focus when enabled — the native autoFocus attribute is a no-op on a disabled mount. */
  autoFocusWhenEnabled?: boolean
  className?: string
}

export const ComposerTextarea = ({
  value,
  onChange,
  onSubmit,
  placeholder,
  disabled,
  readOnly,
  maxHeight = 120,
  autoFocusWhenEnabled,
  className,
}: ComposerTextareaProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    if (autoFocusWhenEnabled && !disabled) {
      textareaRef.current?.focus()
    }
  }, [autoFocusWhenEnabled, disabled])

  return (
    <div
      className="composer-grow w-full min-w-0 flex-1"
      data-replicated-value={value}
      style={{ '--composer-max-height': `${maxHeight}px` } as CSSProperties}
    >
      <InputGroupTextarea
        ref={textareaRef}
        rows={1}
        value={value}
        disabled={disabled}
        readOnly={readOnly}
        placeholder={placeholder}
        aria-label={placeholder}
        onChange={(e: ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value)}
        onKeyDown={(e: KeyboardEvent<HTMLTextAreaElement>) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault()
            onSubmit()
          }
        }}
        className={clsx('scrollbar-hidden block min-h-0 w-full', className)}
      />
    </div>
  )
}
